var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { RootComponentFacade } from './rootComponentFacade';
import { Component } from './component';
import { ComponentEventType } from './componentEvent';
/**
 * The root component to host the rest of the components.
 * There is not limitation right no but ideally there should only be one of these on a page.
 */
var RootComponent = /** @class */ (function (_super) {
    __extends(RootComponent, _super);
    function RootComponent(window, options) {
        var _this = _super.call(this, window, options) || this;
        _this.children = {};
        return _this;
    }
    /**
     * Schedule the disposing of the child on exiting the function.
     * The dispose method is async but we do not want to wait for that.
     *
     * @param child The child that was disposed.
     */
    RootComponent.prototype.scheduleDisposeChild = function (child) {
        var _this = this;
        // Schedule this later
        this.getWindow().setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.disposeChildByRef(child)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, 0);
    };
    /**
     * Dispose a child using it's reference.
     *
     * @param child
     */
    RootComponent.prototype.disposeChildByRef = function (child) {
        return this.disposeChild(child.id);
    };
    /**
     * Dispose a child by using it's id.
     *
     * @param childId The child identifier.
     */
    RootComponent.prototype.disposeChild = function (childId) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        child = this.getChild(childId);
                        if (!child)
                            return [2 /*return*/, Promise.resolve()];
                        return [4 /*yield*/, child.dispose()];
                    case 1:
                        _a.sent();
                        this.children[childId] = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @@inheritdoc
     */
    RootComponent.prototype.mountCore = function () {
        this.callHandler(ComponentEventType.Mounted);
        return _super.prototype.mountCore.call(this);
    };
    /**
     * Add a child component.
     *
     * @param options Child component options.
     */
    RootComponent.prototype.addChild = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var child, id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isInitialized)
                            throw new Error('Wait for the component to initialize before starting to add children.');
                        if (!this.isMounted)
                            throw new Error('Wait for the component to mount before starting to add children.');
                        child = this.options.childFactory.createComponent(this.getWindow(), options, new RootComponentFacade(this.scheduleDisposeChild.bind(this)));
                        return [4 /*yield*/, child.initialize()];
                    case 1:
                        id = (_a.sent()).id;
                        this.children[id] = child;
                        return [4 /*yield*/, child.mount()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, id];
                }
            });
        });
    };
    /**
     * Get the child with the given identifier.
     *
     * @param id The child identifier.
     */
    RootComponent.prototype.getChild = function (id) {
        return id ? (this.children[id] || null) : null;
    };
    /**
     * Remove a child component.
     *
     * @param id The child component identifier.
     */
    RootComponent.prototype.removeChild = function (id) {
        return this.disposeChild(id);
    };
    return RootComponent;
}(Component));
export { RootComponent };
//# sourceMappingURL=rootComponent.js.map